module.exports = __webpack_public_path__ + "img/图片1-4.a3086f43.png";